import gsap from 'gsap';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const Loader = ({done,onExit,Idelay = 4}) => { 
    let preloaderRef = useRef()
    useEffect(()=>{
    if (done) {
      gsap.to(preloaderRef.current, {
        opacity: 0,
        duration: 0.5,  
         delay:Idelay,
        ease: "power2.inOut",
        onComplete: onExit,
      });
    }
  }, [done]);
  return (
    <StyledWrapper ref={preloaderRef} className='z-[4000] bg-black fixed w-full h-full flex items-center justify-center pointer-events-none'>
      <div className="spinner ">
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
        <span />
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .spinner {
    position: relative;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-left: -75px;
  }

  .spinner span {
    position: absolute;
    top: 50%;
    left: var(--left);
    width: 35px;
    height: 7px;
    background: #ffff;
    animation: dominos 1s ease infinite;
    box-shadow: 2px 2px 3px 0px black;
  }

  .spinner span:nth-child(1) {
    --left: 80px;
    animation-delay: 0.125s;
  }

  .spinner span:nth-child(2) {
    --left: 70px;
    animation-delay: 0.3s;
  }

  .spinner span:nth-child(3) {
    left: 60px;
    animation-delay: 0.425s;
  }

  .spinner span:nth-child(4) {
    animation-delay: 0.54s;
    left: 50px;
  }

  .spinner span:nth-child(5) {
    animation-delay: 0.665s;
    left: 40px;
  }

  .spinner span:nth-child(6) {
    animation-delay: 0.79s;
    left: 30px;
  }

  .spinner span:nth-child(7) {
    animation-delay: 0.915s;
    left: 20px;
  }

  .spinner span:nth-child(8) {
    left: 10px;
  }

  @keyframes dominos {
    50% {
      opacity: 0.7;
    }

    75% {
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg);
    }

    80% {
      opacity: 1;
    }
  }`;

export default Loader;
